import { RoleEnum } from '@/shared/api/intranet'

interface CanAccessColleaguesListParams {
  canViewColleaguesList: boolean
  role: Nullable<RoleEnum>
}

/**
 * Проверяет, может ли пользователь открыть список сотрудников.
 * При выключенном флаге доступ остаётся только у ADMIN и SHOP_MANAGER.
 */
export function canAccessColleaguesList(params: CanAccessColleaguesListParams): boolean {
  if (params.canViewColleaguesList) {
    return true
  }

  return params.role === RoleEnum.ADMIN || params.role === RoleEnum.SHOP_MANAGER
}
